import React, { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { Divider, IconButton, Stack, useTheme } from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useSystemConfig, useSystemId } from '../../../hooks/useReduxSelectors';
import { Commands, IotModules } from '../../../actions/apiActions';


const SystemModuleSettings = ({ isAuthorized, isEdge }) => {

  const moduleArray = [
    // { name: "BackUpManager", displayName: "Backup Manager", status: "-" },
    { name: "ControlApp", displayName: "Control App", status: "-" },
    { name: "DataManager", displayName: "Data Manager", status: "-" },
    { name: "EdgeAPI", displayName: "Edge API", status: "-" },
    // { name: "EmissionReporter", displayName: "Emission Reporter", status: "-" },
    { name: "FrontEnd", displayName: "FrontEnd", status: "-" },
    { name: "LocalMongo", displayName: "Local Mongo", status: "-" },
    { name: "MessageStreamer", displayName: "Message Streamer", status: "-" },
    { name: "ProtocolManager", displayName: "Protocol Manager", status: "-" },
    { name: "ProtocolManager2", displayName: "Protocol Manager 2", status: "-" },
    { name: "SystemCommunicator", displayName: "System Communicator", status: "-" },
    // { name: "$edgeHub", displayName: "Edge Hub", status: "-" },
    // { name: "$edgeAgent", displayName: "Edge Agent", status: "-" },
  ];

  const theme = useTheme();
  const systemId = useSystemId();
  const config = useSystemConfig();

  const [modulesWithStatus, setModulesWithStatus] = useState(moduleArray);

  const fetchModules = async () => {
    const payload = {
      customerId: config.CUSTOMER_ID,
      deviceId: config.DEVICE_ID,
      hwId: "EdgeDevice",
    };
    try {
      console.log("Fetching modules with payload:", payload);
      const response = await IotModules.get(config.DATA_URL, payload);
      console.log("response", response);
      if (!response || !response.modules) {
        console.error("No modules found in response:", response);
        return;
      }
      const modules = response.modules;
      console.log("Fetched modules:", modules);
      const updatedModules = moduleArray.map(module => {
        const foundModule = modules.find(m => m.name === module.name);
        return {
          ...module,
          status: foundModule ? foundModule.status : "-",
        };
      });
      setModulesWithStatus(updatedModules);
    }
    catch (error) {
      console.error("Error fetching modules:", error);
    }
  };

  // useEffect(() => {


  //   fetchModules();
  // }, []);

  const sendRestartCommand = async (moduleName) => {
    const payload = {
      origin: config.APP_ENV,
      customerId: config.CUSTOMER_ID,
      deviceId: config.DEVICE_ID,
      hwId: "EdgeDevice",
      moduleName: moduleName,
      command: "ModuleRestart"
    };
    console.log("Restarting module:", moduleName, "with payload:", payload);
    try {
      //  response = await Commands.post(config.COMMAND_URL
      const response = await Commands.post(config.COMMAND_URL, payload);
      console.log("Restart command response:", response);
      if (response && response.success) {
        console.log(`Module ${moduleName} restarted successfully.`);
      } else {
        console.error(`Failed to restart module ${moduleName}.`, response);
      }
    } catch (error) {
      console.error(`Error restarting module ${moduleName}:`, error);
    }
  };

  const handleRestart = (moduleName) => {
    sendRestartCommand(moduleName);
  };

  const determineStatusColor = (status) => {
    switch (status) {
      case "Running":
        return "success";
      case "Stopped":
        return "error";
      case "Starting":
        return "warning";
      default:
        return "text.disabled";
    }
  };

  return (
    <Accordion
      onChange={(event, expanded) => {
        if (expanded) {
          fetchModules();
        }
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="system-module-settings-content"
        id="system-module-settings-header"
        sx={{ backgroundColor: theme.palette.primary.main }}
      >
        <Typography sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>System Modules</Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{ backgroundColor: theme.palette.background.light }}
      >
        {/* <Typography variant="h5">
          Module Restarts
        </Typography> */}
        <Stack spacing={1} direction="column" sx={{ justifyContent: "flex-start" }} >
          {modulesWithStatus.map((module, index) => (
            <React.Fragment key={index}>
              <Stack direction="row" key={index}>
                <Stack direction={{ xs: "column", md: "row" }} sx={{ alignItems: { xs: "flex-start", md: "center" } }} >
                  {/* <Stack direction="row" sx={{ minWidth: "200px", padding: "0px 6px" }}> */}
                  <Typography color="text.primary" sx={{ fontSize: "18px", fontWeight: 500, minWidth: "200px", padding: "0px 6px" }}>
                    {module.displayName}
                  </Typography>
                  {/* </Stack> */}
                  <Stack direction="row" spacing={1} sx={{ minWidth: "180px", padding: "0px 6px", alignItems: { xs: "flex-start", md: "center" } }}>
                    <Typography>
                      Status
                    </Typography>
                    <Typography color={determineStatusColor(module.status)}>
                      {module.status}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack direction="row" spacing={1} sx={{ minWidth: "200px" }}>
                  <Button
                    color="warning" size="large" onClick={() => handleRestart(module.name)}
                    disabled={(!isAuthorized && !isEdge)}
                  >
                    <RestartAltIcon sx={{ marginRight: 2 }} />
                    <Typography color="text.primary">Restart</Typography>
                  </Button>
                </Stack>
              </Stack>
              <Divider />
            </React.Fragment>
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default SystemModuleSettings;;